import React from "react";
import { OptInPartner } from "../../api/optInOffers";
import { formatCurrency, formatInteger } from "../../helpers/formatNumber";

interface OptInPartnerCardsProps {
  partners: OptInPartner[];
  selectedBusinessId: string;
  onSelect: (businessContentfulId: string) => void;
}

export const OptInPartnerCards: React.FC<OptInPartnerCardsProps> = ({
  partners,
  selectedBusinessId,
  onSelect,
}) => (
  <div className="flex flex-wrap gap-4">
    {partners.map((partner) => {
      const isSelected = partner.businessContentfulId === selectedBusinessId;
      return (
        <button
          key={partner.businessContentfulId}
          type="button"
          onClick={() => onSelect(partner.businessContentfulId)}
          className={`bg-white rounded-lg shadow p-4 min-w-[220px] text-left border-2 ${
            isSelected ? "border-purple-500" : "border-transparent"
          }`}
        >
          <div className="text-gray-500 text-sm">
            {partner.businessName ?? partner.businessContentfulId}
          </div>
          <div className="text-2xl font-semibold mt-1">
            {formatInteger(partner.optedInCount)}
            <span className="text-base font-normal text-gray-500"> opted in</span>
          </div>
          {partner.missedCount > 0 && (
            <div className="text-sm text-red-600 mt-1">
              {formatInteger(partner.missedCount)} missed ·{" "}
              {formatInteger(partner.missedTransactionsCount)} transactions ·{" "}
              {formatCurrency(partner.missedAmount)} kr
            </div>
          )}
          {partner.compensatedRidesCount > 0 && (
            <div className="text-sm text-blue-600 mt-1">
              {formatInteger(partner.compensatedPeopleCount)} compensated ·{" "}
              {formatInteger(partner.compensatedRidesCount)} rides ·{" "}
              {formatCurrency(partner.compensatedCashback)} kr cashback
            </div>
          )}
        </button>
      );
    })}
  </div>
);
